import { ConfirmChangeModal } from '@jane/shared/components';

export interface ConfirmDisableModalProps {
  itemName: string;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  type: 'gold' | 'embedded';
}

const SUBTITLES = {
  gold: 'Jane Gold customers have 35% higher cart sizes on average. Are you sure you want to hide the Jane Gold row?',
  embedded:
    "You've embedded this row off-menu on your website. If you remove the row it will be removed from the embedded location.",
};

const TITLES = {
  gold: (itemName: string) => `Hide Jane Gold ${itemName}`,
  embedded: (itemName: string) => `Disable ${itemName}`,
};

export const ConfirmDisableModal = ({
  itemName,
  type,
  ...alertProps
}: ConfirmDisableModalProps) => {
  const title = TITLES[type](itemName);

  return (
    <ConfirmChangeModal
      {...alertProps}
      appId="parent"
      title={`${title}?`}
      subtitle={SUBTITLES[type]}
      cancelLabel="Cancel"
      confirmLabel={title}
      confirmButtonVariant="destructive"
      borderRadius={40}
    />
  );
};
